import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// The sidebar plan card (plan, usage, Manage subscription) — company admins only; HMs and recruiters never see billing.
const PLAN = { enterprise: ['🚀', 'text-[#6D28D9]'], professional: ['💼', 'text-[#0066CC]'], essential: ['📦', 'text-[#15803D]'] };

function Bar({ label, used, limit, tone }) {
  if (!limit) return null;
  const pct = Math.min(100, Math.round(((used || 0) / limit) * 100));
  return (
    <div>
      <div className="flex justify-between text-[11px] text-[#64748B]"><span>{label}</span><span>{used || 0}/{limit}</span></div>
      <div className="h-1.5 rounded-full bg-[#EEF1F6] mt-0.5"><div className={`h-1.5 rounded-full ${tone}`} style={{ width: `${pct}%` }} /></div>
    </div>
  );
}

export default function PlanCard({ company, onManage }) {
  const navigate = useNavigate();
  const [sub, setSub] = useState(null);
  useEffect(() => {
    const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    fetch(`${BASE}/api/stripe/subscription`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => (r && r.ok ? r.json() : null)).then((d) => { if (d) setSub(d); }).catch(() => {});
  }, []);
  const plan = String((company && company.subscription_plan) || 'essential').toLowerCase();
  const [icon, tone] = PLAN[plan] || PLAN.essential;
  return (
    <div className="px-3 pb-4" data-testid="plan-card">
      <div className="rounded-[12px] border border-[#E6E9F0] bg-[#FAFBFD] p-3.5 space-y-2.5">
        <div className="flex items-center gap-2"><span aria-hidden="true">{icon}</span>
          <div><p className="text-[10px] font-bold uppercase tracking-widest text-[#94A3B8]">Current plan</p>
            <p className={`text-sm font-bold capitalize ${tone}`}>{plan}</p></div></div>
        {sub && <div className="space-y-1.5">
          <Bar label="JD uploads" used={sub.phase1_used} limit={sub.phase1_limit} tone="bg-[#0066CC]" />
          <Bar label="Intake calls" used={sub.phase2_used} limit={sub.phase2_limit} tone="bg-[#7EC845]" />
          <Bar label="Interviews" used={sub.phase3_used} limit={sub.phase3_limit} tone="bg-[#7C3AED]" />
        </div>}
        <button type="button" onClick={() => (onManage ? onManage() : navigate('/dashboard/company-admin?menu=subscription'))}
          className="w-full rounded-lg bg-white border border-[#D9DEE8] py-1.5 text-xs font-bold text-[#0F172A] hover:bg-[#F5F7FB]">Manage subscription</button>
      </div>
    </div>
  );
}
